import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Posts a lead/enquiry to the backend. Returns true on success.
export const postLead = async (payload) => {
  const body = {
    name: payload.name || "",
    email: payload.email || "",
    phone: payload.phone || "",
    destination: payload.destination || "",
    message: payload.message || "",
    source: payload.source || "contact",
  };
  await axios.post(`${API}/contact`, body);
  return true;
};
